import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    t
  } = useLanguage();
  const faqItems = [{
    q: 'faq.q1',
    a: 'faq.a1'
  }, {
    q: 'faq.q2',
    a: 'faq.a2'
  }, {
    q: 'faq.q3',
    a: 'faq.a3'
  }, {
    q: 'faq.q4',
    a: 'faq.a4'
  }, {
    q: 'faq.q5',
    a: 'faq.a5'
  }];
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderTop: '1px solid var(--border)'
  }} data-id="element-82">
      <div className="relative z-10 mx-auto max-w-3xl" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="mb-12 text-center" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-bold" style={{
          color: 'var(--text-primary)'
        }} data-id="element-85">
            {t('faq.title')}
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-86">
          {faqItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.35,
          delay: index * 0.04,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} data-id="element-87">
              <div className="rounded-2xl border overflow-hidden" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-primary)'
          }} data-id="element-88">
                <button onClick={() => toggleItem(index)} className="flex w-full items-center justify-between p-6 text-left transition-colors" aria-expanded={openIndex === index} data-id="element-89">
                  <h3 className="pr-4 font-bold text-base sm:text-lg" style={{
                color: 'var(--text-primary)'
              }} data-id="element-90">
                    {t(item.q)}
                  </h3>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-91">
                    <ChevronDownIcon className="h-5 w-5" style={{
                  color: 'var(--text-muted)'
                }} data-id="element-92" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-93">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.25, 0.46, 0.45, 0.94]
              }} style={{
                overflow: 'hidden'
              }} data-id="element-94">
                      <div className="border-t px-6 pb-6 pt-4" style={{
                  borderColor: 'var(--border)'
                }} data-id="element-95">
                        <p className="leading-relaxed text-base" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-96">
                          {t(item.a)}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}